export default {
  common: {
    appName: "Flash Cards",
    tagline: "Meistere Kopfrechnen, ein Blitz nach dem anderen",
    startTraining: "Training starten",
    stop: "Stoppen",
    save: "Speichern",
    reset: "Zurücksetzen",
    clear: "Löschen",
    delete: "Löschen",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    yes: "Ja",
    no: "Nein",
    loading: "Lädt...",
    error: "Fehler",
    success: "Erfolg",
    backToHome: "Zurück zur Startseite"
  },
  navigation: {
    flashCalculation: "Blitz-Berechnung",
    history: "Verlauf",
    settings: "Einstellungen",
    tryTheApp: "App ausprobieren"
  },
  landing: {
    hero: {
      title: "Trainiere deine Kopfrechen-Reflexe",
      subtitle:
        "Baue blitzschnelle Zahlenkenntnisse mit abakus-inspirierten Blitz-Übungen auf. Spaßig, fokussiert und effektiv—besonders für Kinder und Schüler.",
      startTraining: "Training starten",
      learnMore: "Mehr erfahren"
    },
    whyAbacus: {
      title: "Warum abakus-basiertes Lernen?",
      description:
        "Der Abakus hat Lernenden über Jahrhunderte geholfen—nicht nur beim Rechnen, sondern beim Denken in Zahlen. Das Üben mit abakus-artigen Blitzen baut Aufmerksamkeit, Arbeitsgedächtnis und Zahlenverständnis auf. Es ist ein spielerischer Weg zu selbstbewusstem Kopfrechnen, besonders für Kinder.",
      focus: {
        title: "Fokus",
        description:
          "Kurze Einheiten fördern anhaltende Aufmerksamkeit und Konzentration."
      },
      speed: {
        title: "Geschwindigkeit",
        description: "Schnelle Übungen stärken Erinnerung und mentale Beweglichkeit."
      },
      numberSense: {
        title: "Zahlenverständnis",
        description: "Sieh Muster und Beziehungen, nicht nur einzelne Ziffern."
      },
      confidence: {
        title: "Selbstvertrauen",
        description:
          "Kleine Erfolge führen zu mathematischer Meisterschaft und Selbstsicherheit."
      }
    },
    history: {
      title: "Abakus in Japan: vom Suanpan zum modernen Soroban",
      description:
        "Entdecke die faszinierende Reise des Abakus durch die japanische Geschichte und seine Entwicklung zu einem mächtigen kognitiven Trainingswerkzeug.",
      origins: {
        title: "Ursprung & Verbreitung",
        description:
          "Der Abakus gelangte aus China (Suanpan) nach Japan, vermutlich bereits im 14. Jahrhundert über Korea; seine Nutzung verbreitete sich besonders während der Edo-Zeit (1603–1867)."
      },
      simplification: {
        title: "Vereinfachung des Instruments",
        description:
          "Ausgehend vom chinesischen 2/5-Layout (zwei obere, fünf untere Perlen) übernahmen die Japaner zunächst ein 1/5-Layout und später die moderne 1/4-Konfiguration, die 1938 standardisiert wurde—schneller und effizienter für Dezimalrechnungen."
      },
      keyFigure: {
        title: "Schlüsselfigur",
        description:
          "Der Mathematiker Seki Kōwa (17. Jahrhundert) studierte den Soroban und seine Methoden umfassend und trug wesentlich zur Verbreitung der Techniken und des Unterrichts bei."
      },
      iconicMoment: {
        title: "Ein ikonischer Moment",
        description:
          "Am 12. November 1946 fand in Tokio ein Wettkampf zwischen einem Soroban-Meister und einem US-Soldaten mit elektronischem Rechner statt. Der Soroban gewann vier von fünf Runden—ein eindrucksvoller Beleg für seine Geschwindigkeit und Genauigkeit."
      },
      flashAnzan: {
        title: "Flash Anzan",
        description:
          "Neben traditionellen Wettbewerben gibt es in Japan „Flash Anzan“-Events: Zahlen erscheinen in hoher Geschwindigkeit auf dem Bildschirm und werden mental berechnet, indem die Perlenbewegungen visualisiert werden. Rekorde zeigen eine bemerkenswerte Verarbeitungsgeschwindigkeit."
      },
      educationToday: {
        title: "Heute in der Bildung",
        description:
          "Obwohl nicht überall verpflichtend, bleibt der Soroban Teil des Lehrplans an einigen Grundschulen und Trainingszentren, da er Konzentration, Arbeitsgedächtnis und Zahlensinn—besonders bei Kindern—fördert."
      },
      quote:
        "Der Soroban verbindet Tradition mit modernem kognitivem Training: ein simples Werkzeug, das Selbstvertrauen und schnelle Rechenfertigkeiten aufbaut."
    },
    howItWorks: {
      title: "Wie Flash Cards funktioniert",
      step1: {
        title: "Wähle dein Tempo",
        description:
          "Wähle Ziffern, Geschwindigkeit und wie viele Blitze angezeigt werden sollen. Passe dein Training an."
      },
      step2: {
        title: "Beobachte & berechne",
        description:
          "Zahlen erscheinen kurz—verfolge sie mental, abakus-artig. Baue deine mentalen Rechenfähigkeiten auf."
      },
      step3: {
        title: "Ergebnisse prüfen",
        description:
          "Enthülle die Summe und sieh deinen Fortschritt über die Zeit. Verfolge deine Verbesserungen."
      },
      tryItNow: "Jetzt ausprobieren"
    },
    cta: {
      title: "Bereit, dein Kopfrechnen zu schärfen?",
      description:
        "Schließe dich Tausenden von Schülern und Lehrern an, die Flash Cards verwenden, um schnellere, selbstbewusstere Kopfrechenfähigkeiten aufzubauen.",
      startTrainingNow: "Training jetzt starten"
    }
  },
  flashCalculation: {
    title: "Blitz-Berechnungstraining",
    status: {
      active: "Aktiv",
      readyToStart: "Bereit zum Starten"
    },
    progress: {
      currentNumber: "Aktuelle Zahl",
      total: "Gesamt"
    },
    result: {
      title: "Ergebnis",
      sequence: "Sequenz",
      sum: "Summe",
      showResult: "Ergebnis anzeigen",
      numberSequence: "Zahlenfolge:",
      total: "Gesamt:",
      successMessage: "Großartig! Du hast die Berechnung erfolgreich abgeschlossen."
    },
    idle: {
      title: "Blitz-Berechnungstraining",
      subtitle: "Klicke \"Start\" um das Training zu beginnen"
    }
  },
  settings: {
    title: "Einstellungen",
    flashCalculation: {
      title: "Blitz-Berechnung",
      digitLength: "Ziffernlänge",
      numberOfDisplays: "Anzahl der Anzeigen",
      speed: "Geschwindigkeit",
      editSpeed: "Geschwindigkeit bearbeiten",
      showingMinusNumbers: "Minuszahlen anzeigen",
      showingDecimalNumbers: "Dezimalzahlen anzeigen",
      decimalLength: "Dezimalstellen",
      fontSize: "Schriftgröße",
      enableAudio: "Audio aktivieren",
      saveSettings: "Einstellungen speichern",
      resetSettings: "Einstellungen zurücksetzen"
    },
    speed: {
      slowest: "Langsamste",
      slow: "Langsam",
      normal: "Normal",
      fast: "Schnell",
      fastest: "Schnellste"
    }
  },
  history: {
    title: "Trainingsverlauf",
    subtitle: "Verfolge deinen Fortschritt und deine Verbesserung",
    noHistory: "Noch kein Verlauf",
    noHistoryDescription:
      "Vervollständige einige Trainingseinheiten, um deinen Fortschritt hier zu sehen!",
    totalSessions: "Gesamte Sitzungen",
    clearHistory: "Verlauf löschen",
    clearHistoryConfirm:
      "Bist du sicher, dass du den gesamten Verlauf löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    clearAll: "Alles löschen",
    numbers: "Zahlen",
    deleteEntry: "Eintrag löschen"
  },
  footer: {
    builtFor: "Gebaut für besseres Kopfrechnen",
    developedBy: "Entwickelt von",
    copyright:
      "Trainiere deinen Geist, ein Blitz nach dem anderen."
  }
};
